import { Patient } from "../../../api/patient.types";
import { PatientsByphoneMainAction } from "./patients.byphone.main.types";

export const patientsByphoneMainRequest = (): PatientsByphoneMainAction => ({ type: 'PATIENTS_BYPHONE_MAIN_REQUEST' })

export const patientsByphoneMainSuccess = (users: Patient[]): PatientsByphoneMainAction => ({ type: 'PATIENTS_BYPHONE_MAIN_SUCCESS', params: { users } })

export const patientsByphoneMainFailure = () => ({ type: 'PATIENTS_BYPHONE_MAIN_FAILURE' } as const)